module.exports = __webpack_public_path__ + "static/media/instagram.50a4a3f8.JPG";